import { Box, Tooltip, Typography, Divider, Spacer } from '@telus-uds/components-web'
import { Positioned } from './Styles'
import { LegalTextRenderer } from '../../../utils/text/TextRenderer'
import { BlockRenderer } from '../../../renderer/contentful/BlockRenderer'
import { PlanSectionDetailFields } from './PlanSection'

export type ExtraDetailsSectionProps = {
  extraDetailsSection: PlanSectionDetailFields[]
}

const ExtraDetailsSection = ({ extraDetailsSection }: ExtraDetailsSectionProps) => {
  return (
    <Box>
      <Spacer space={6} />
      <Divider variant={{ decorative: true }} />
      <Spacer space={4} />
      {extraDetailsSection.map((sectionDetail, idx) => {
        let spacing = 16
        if (idx == extraDetailsSection.length - 1) {
          spacing = 0
        }
        return (
          <div style={{ display: 'flex', marginBottom: `${spacing}px` }} key={idx}>
            {!sectionDetail.headingIcon && <Typography>•</Typography>}
            {sectionDetail.headingIcon && (
              <Positioned icon={true}>
                <BlockRenderer block={sectionDetail.headingIcon} />
              </Positioned>
            )}
            <Spacer space={3} direction="row" />
            <Typography>
              <LegalTextRenderer>{sectionDetail.descriptionText}</LegalTextRenderer>
            </Typography>
            {sectionDetail.tooltipText && <Spacer space={2} direction="row" />}
            {sectionDetail.tooltipText && (
              <Positioned>
                <Tooltip content={sectionDetail.tooltipText}></Tooltip>
              </Positioned>
            )}
          </div>
        )
      })}
    </Box>
  )
}

export default ExtraDetailsSection
